import React, { forwardRef, ReactNode, ForwardedRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const LinkBehavior = forwardRef((props: { href: string; children?: ReactNode }, ref: ForwardedRef<HTMLAnchorElement>) => {
    const { href, ...other } = props;
    // Map href (MUI) -> to (react-router)
    return (
      <RouterLink data-testid="custom-link" ref={ref} to={href} {...other} />
    );
  }
);

export default LinkBehavior;